/**
 * Product Model
 *
 * @returns {void}
 */
const productModel = () => {
    //const $image = $('.p-model__image');

    const $model = $('.p-model');
    const $model_wrap = $model.find('.p-model__image-wrap');
    const $trigger = $model.find('.wave');
    const $boxes = $model.find('.p-model__box');
    const $markers = $model.find('.p-model__marker');

    let supportsTouch, events;

    if ('ontouchstart' in window || window.navigator.msPointerEnabled || 'ontouchstart' in document.documentElement){

        supportsTouch = true;

    }

    if(!supportsTouch) {
        events = {
            click: 'mousedown',
        }
    }
    else {
        events = {
            click: 'touchstart',
        }
    }


    $trigger.on(events.click, function () {
        const $item = $(this).closest('.p-model__marker');
        const $box = $boxes.eq($item.data('index'));

        if ($item.hasClass('is-active')) {

        } else {
            $boxes.removeClass('active');
            $markers.removeClass('is-active');
            $item.addClass('is-active');
            $box.addClass('active');
        }
    });

    $trigger.first().trigger(events.click);

    $boxes.each(function () {

        let $box = $(this);
        let icon = $box.find('.p-model__thumbnail');
        let content = $box.find('.p-model__content');

        if(icon.height() > content.height()) {
            $box.addClass('centered-content')
        }
    })
};

export default productModel;
